var path = 'integration/integration-card.tpl.html';
var html = " <div flex layout=column> <div flex style=text-transform:uppercase>{{ vm.types.integrationType[vm.item.type].name | translate }}</div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/integration/integration-card.tpl.html
// module id = 1533
// module chunks = 1